var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echart",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"90%","height":"100%"},attrs:{"id":_vm.main}})])
}
var staticRenderFns = []

export { render, staticRenderFns }